"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherHealthServicesIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("./IconContainer"));
const OtherHealthServicesIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-other-health-servies", size, className) }, props),
        react_1.default.createElement("svg", { width: "69", height: "70", viewBox: "0 0 69 70", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("path", { d: "M46 18.9087C46 17.3837 45.3942 12.2896 44.3159 11.2112C43.2375 10.1329 41.775 9.5271 40.25 9.5271H28.75C27.225 9.5271 25.7625 10.1329 24.6841 11.2112C23.6058 12.2896 23 17.3837 23 18.9087M11.5 21.0271H57.5C60.6756 21.0271 63.25 23.6015 63.25 26.7771V60.9745C63.25 64.1501 60.6756 66.7245 57.5 66.7245H11.5C8.32436 66.7245 5.75 64.1501 5.75 60.9745V26.7771C5.75 23.6015 8.32436 21.0271 11.5 21.0271Z", stroke: "currentColor", strokeWidth: "3.5", strokeLinecap: "round", strokeLinejoin: "round" }),
            react_1.default.createElement("rect", { x: "21.7891", y: "41.7573", width: "25.4211", height: "5.44737", rx: "2.72368", fill: "#0573D8" }),
            react_1.default.createElement("rect", { x: "31.7764", y: "57.1917", width: "25.4211", height: "5.44737", rx: "2.72368", transform: "rotate(-90 31.7764 57.1917)", fill: "currentColor" }))));
};
exports.OtherHealthServicesIcon = OtherHealthServicesIcon;
OtherHealthServicesIcon.defaultProps = {
    title: "Other Health Services",
};
exports.default = OtherHealthServicesIcon;
//# sourceMappingURL=OtherHealthServices.js.map